module.exports = __webpack_public_path__ + "img/G.14d097e6.png";